import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import changeTrackable, { IChangeTrackable } from './changeTrackable';
import model from './model';
import sizeFactory, { ISize } from './sizeModel';

export interface IJobCostSpecification extends IModel, IChangeTrackable {
	workAreaKey?: string;
	group?: number;
	specKey?: string;
	name?: string;
	sortIndex?: number;
	value?: string;
	note?: string;
	applianceSize: ISize;
	openingSize: ISize;
	duplicate(): IJobCostSpecification;
}

const jobCostSpecificationFactory = modelFactory.createFactory<IJobCostSpecification>('JobCostSpecification', _.assign({}, model, changeTrackable, {
	workAreaKey: {
		setFilters: valueFilters.clean
	},
	// required: specGroups enum value
	group: {
		setFilters: valueFilters.toNumber,
		rules: validator.enum('specGroups', true) // disallow 0
	},
	// optional: lower-case key used to map to a spec definition
	specKey: {
		setFilters: valueFilters.clean
	},
	// display name of the spec, copied from spec definition
	name: {
		setFilters: valueFilters.toString,
		rules: validator.required()
	},
	sortIndex: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	},
	// for Appliance specs, this holds the "description"
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string(true)
	},
	// for Appliance specs, this holds the "application notes"
	note: {
		setFilters: valueFilters.toString,
		rules: validator.string(true)
	},
	// for Appliance Specs only
	applianceSize: {
		setFilters: valueFilters.toModel(sizeFactory),
		defaultValue: { depth: 0, width: 0, height: 0 },
		rules: validator.validModel(sizeFactory.rules())
	},
	// for Appliance Specs only
	openingSize: {
		setFilters: valueFilters.toModel(sizeFactory),
		defaultValue: { depth: 0, width: 0, height: 0 },
		rules: validator.validModel(sizeFactory.rules())
	},
	duplicate: function () {
		return jobCostSpecificationFactory(_.omit(this.toDocument(), 'key', 'rootKey', 'changeOrderKey'));
	}
}));

export default jobCostSpecificationFactory;